import { render, staticRenderFns } from "./GeneralConfig.vue?vue&type=template&id=c718a0a0&scoped=true&"
import script from "./GeneralConfig.vue?vue&type=script&lang=js&"
export * from "./GeneralConfig.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConfig.vue?vue&type=style&index=0&id=c718a0a0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c718a0a0",
  null
  
)

export default component.exports